/**
 * api-受监护人员信息
 */
import { post } from '@/utils/http'
// 获取受监护人员
export const apiGetAlertPerson = p => post('/alert/getAlertPerson.do', p)
export const apiGetSimpleAlertPerson = p => post('/alert/getSimpleAlertPerson.do', p)
export const apiGetAlertPersonPage = p => post('/alert/getAlertPersonPage.do', p)
export const apiAddAlertPerson = p => post('/alert/addAlertPerson.do', p)
export const apiUpdateAlertPerson = p => post('/alert/updateAlertPerson.do', p)
export const apiDeleteAlertPerson = p => post('/alert/deleteAlertPerson.do', p)
// 监护设备
export const apiGetAlertPersonDevice = p => post('/alert/getAlertPersonDevice.do', p)
export const apiGetAlertPersonDevicePage = p => post('/alert/getAlertPersonDevicePage.do', p)
export const apiAddAlertPersonDevice = p => post('/alert/addAlertPersonDevice.do', p)
export const apiUpdateAlertPersonDevice = p => post('/alert/updateAlertPersonDevice.do', p)
export const apiDeleteAlertPersonDevice = p => post('/alert/deleteAlertPersonDevice.do', p)
// 报警信息
export const apiGetAlertMessage = p => post('/alert/getAlertMessage.do', p)
export const apiGetAlertMessagePage = p => post('/alert/getAlertMessagePage.do', p)
export const apiUpdateAlertMessage = p => post('/alert/updateAlertMessage.do', p)
export const apiGetAlertMessageDetail = p => post('/alert/getAlertMessageDetail.do', p)
export const apiGetPersonAlertMessage = p => post('/alert/getPersonAlertMessage.do', p)
// 记录
export const apiGetAlertPersonLog = p => post('/alert/getAlertPersonLog.do', p)
export const apiGetAlertTotalCount = p => post('/alert/getAlertTotalCount.do', p)
export const apiGetAlertPersonLogList = p => post('/alert/getAlertPersonLogPage.do', p)
export const apiGetJkytLog = p => post('/alert/getJkytLog.do', p)




